import { useInfiniteQuery } from '@tanstack/react-query';
import { eventFeed, EventFeedRequest, EventFeedResponse } from '@toggle/toggle';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

const QUERY_KEY_EVENT_FEED = 'QUERY_KEY_EVENT_FEED';

interface PageParam {
  next?: string;
  prev?: string;
}

export const useEventFeed = (body: EventFeedRequest) =>
  useInfiniteQuery({
    queryKey: [QUERY_KEY_EVENT_FEED, body],
    queryFn: ({ signal, pageParam }) => {
      const { path, schema } = eventFeed.postFeedEvents;
      return wretchRequest<EventFeedResponse>(path, {
        method: 'post',
        body: { ...body, ...pageParam },
        schema,
        signal,
      });
    },
    initialPageParam: {} as PageParam,
    getNextPageParam: (lastPage): PageParam | undefined =>
      lastPage?.next_cursor ? { next: lastPage.next_cursor } : undefined,
    getPreviousPageParam: (firstPage): PageParam | undefined =>
      firstPage?.prev_cursor ? { prev: firstPage.prev_cursor } : undefined,
  });

export const postEventRead = (eventId: string) => {
  const { path } = eventFeed.postEventRead;
  return wretchRequest(path(eventId), {
    method: 'post',
  });
};
